/**
 * Frame presets used by ViewOnWall (and any future room visualizer).
 *
 * All sizes in CENTIMETRES so they stay proportional to the artwork after
 * the user calibrates their photo's real-world width.
 *
 * Sourced from a reference shot (IMG_9224 — Hockney with light oak + cream
 * mat) and matched to Gabrielle's Picture Framing house style.
 */
export const FRAME_PRESETS = {
  none: {
    label: 'No frame',
    frameCm: 0,
    matCm: 0,
    frameBg: 'transparent',
    shadow: 'none',
  },
  natural: {
    label: 'Natural oak',
    frameCm: 2.5,
    matCm: 8,
    frameBg: 'linear-gradient(135deg,#e6c79a 0%,#d4ad7b 45%,#b08157 100%)',
    shadow: '0 22px 40px -14px rgba(0,0,0,0.45), 0 5px 12px rgba(0,0,0,0.25)',
  },
  white: {
    label: 'White wood',
    frameCm: 2.5,
    matCm: 8,
    frameBg: 'linear-gradient(135deg,#fafafa 0%,#ffffff 45%,#e8e8e8 100%)',
    shadow: '0 22px 40px -14px rgba(0,0,0,0.35), 0 5px 12px rgba(0,0,0,0.18)',
  },
  black: {
    label: 'Black wood',
    frameCm: 2.5,
    matCm: 8,
    frameBg: 'linear-gradient(135deg,#1f1f1f 0%,#2a2a2a 45%,#0e0e0e 100%)',
    shadow: '0 22px 40px -14px rgba(0,0,0,0.5), 0 5px 12px rgba(0,0,0,0.3)',
  },
  gold: {
    label: 'Gold leaf',
    frameCm: 3,
    matCm: 8,
    frameBg: 'linear-gradient(135deg,#e6c66c 0%,#c9a247 45%,#9a7727 100%)',
    shadow: '0 24px 42px -14px rgba(0,0,0,0.5), 0 5px 12px rgba(0,0,0,0.28)',
  },
};

// Archival-cream mat colour — same as Gabrielle's Picture Framing house standard
export const MAT_COLOR = '#f8f4ea';

// Ordered list of frame keys for UI rendering (don't rely on Object.keys()
// because some bundlers don't preserve insertion order — this matches the
// canonical picker layout).
export const FRAME_KEYS = ['none', 'natural', 'white', 'black', 'gold'];
